// src/app/services/compression.service.ts
import { Injectable } from '@angular/core';
import { gzip, ungzip } from 'pako';

@Injectable({
  providedIn: 'root',
})
export class CompressionService {
  constructor() {}

  compressString(input: string): string {
    const compressed = gzip(input);
    return btoa(String.fromCharCode(...compressed));
  }

  decompressString(base64: string): string {
    const binaryString = atob(base64);
    const byteArray = Uint8Array.from(binaryString, char => char.charCodeAt(0));
    return ungzip(byteArray, { to: 'string' });
  }
}
